export default "__VITE_ASSET__DBRGfKTY__"